import { __assign } from "tslib";
import * as React from 'react';
export var Hash = function (props) { return React.createElement("span", __assign({}, props, { className: "hash" })); };
//# sourceMappingURL=index.js.map